var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavDashboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 32.1131C6.675 32.1131 5.969 31.8196 5.382 31.2326C4.795 30.6456 4.501 29.9391 4.5 29.1131V8.1131C4.5 7.2881 4.794 6.5821 5.382 5.9951C5.97 5.4081 6.676 5.1141 7.5 5.1131H16.5V32.1131H7.5ZM19.5 32.1131V18.6131H31.5V29.1131C31.5 29.9381 31.2065 30.6446 30.6195 31.2326C30.0325 31.8206 29.326 32.1141 28.5 32.1131H19.5ZM19.5 15.6131V5.1131H28.5C29.325 5.1131 30.0315 5.4071 30.6195 5.9951C31.2075 6.5831 31.501 7.2891 31.5 8.1131V15.6131H19.5Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 32.1131C6.675 32.1131 5.969 31.8196 5.382 31.2326C4.795 30.6456 4.501 29.9391 4.5 29.1131V8.1131C4.5 7.2881 4.794 6.5821 5.382 5.9951C5.97 5.4081 6.676 5.1141 7.5 5.1131H16.5V32.1131H7.5ZM19.5 32.1131V18.6131H31.5V29.1131C31.5 29.9381 31.2065 30.6446 30.6195 31.2326C30.0325 31.8206 29.326 32.1141 28.5 32.1131H19.5ZM19.5 15.6131V5.1131H28.5C29.325 5.1131 30.0315 5.4071 30.6195 5.9951C31.2075 6.5831 31.501 7.2891 31.5 8.1131V15.6131H19.5Z",
    fill: "url(#paint0_linear_698_10877)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_10877",
    x1: 4.5,
    y1: 18.655,
    x2: 31.652,
    y2: 18.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavDashboardicon);
export default __webpack_public_path__ + "static/media/sidenav_dashboardicon.02295cf827d1ef86562cfcaca1925d2f.svg";
export { ForwardRef as ReactComponent };